"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "l-aquila": {
    "90bf1774": [{
      "hkey": "1862f7e5",
      "slug": "bazzano-monticchio-onna-san-gregorio",
      "name": "Bazzano-Monticchio-Onna-San Gregorio",
      "primary": true,
      "skipSearch": false
    }],
    "bazzano": [{
      "hkey": "1862f7e5",
      "slug": "bazzano-monticchio-onna-san-gregorio",
      "name": "Bazzano-Monticchio-Onna-San Gregorio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "469b493a": [{
      "hkey": "5a63be8a",
      "slug": "casaline-menzano-santi",
      "name": "Casaline-Menzano-Santi",
      "primary": true,
      "skipSearch": false
    }],
    "casaline": [{
      "hkey": "5a63be8a",
      "slug": "casaline-menzano-santi",
      "name": "Casaline-Menzano-Santi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f2f3ea3b": [{
      "hkey": "947f27c5",
      "slug": "preturo-colle-di-preturo-cese",
      "name": "Preturo-Colle di Preturo-Cese",
      "primary": true,
      "skipSearch": false
    }],
    "cese": [{
      "hkey": "947f27c5",
      "slug": "preturo-colle-di-preturo-cese",
      "name": "Preturo-Colle di Preturo-Cese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "l-aquila"
    }],
    "d51155dd": [{
      "hkey": "924b0799",
      "slug": "bagno",
      "name": "Bagno",
      "primary": true,
      "skipSearch": false
    }],
    "civita-di-bagno": [{
      "hkey": "924b0799",
      "slug": "bagno",
      "name": "Bagno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "l-aquila"
    }],
    "d282bbf8": [{
      "hkey": "947f27c5",
      "slug": "preturo-colle-di-preturo-cese",
      "name": "Preturo-Colle di Preturo-Cese",
      "primary": true,
      "skipSearch": false
    }],
    "colle-di-preturo": [{
      "hkey": "947f27c5",
      "slug": "preturo-colle-di-preturo-cese",
      "name": "Preturo-Colle di Preturo-Cese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "l-aquila"
    }],
    "ef7805e1": [{
      "hkey": "5debdebe",
      "slug": "roio",
      "name": "Roio",
      "primary": true,
      "skipSearch": false
    }],
    "colle-di-roio": [{
      "hkey": "5debdebe",
      "slug": "roio",
      "name": "Roio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "7280ed8b": [{
      "hkey": "924b0799",
      "slug": "bagno",
      "name": "Bagno",
      "primary": true,
      "skipSearch": false
    }],
    "cominio": [{
      "hkey": "924b0799",
      "slug": "bagno",
      "name": "Bagno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "l-aquila"
    }],
    "e025513e": [{
      "hkey": "288430e7",
      "slug": "pianola-malepasso-san-cipriano-esperita",
      "name": "Pianola-Malepasso-San Cipriano-Esperita",
      "primary": true,
      "skipSearch": false
    }],
    "esperita": [{
      "hkey": "288430e7",
      "slug": "pianola-malepasso-san-cipriano-esperita",
      "name": "Pianola-Malepasso-San Cipriano-Esperita",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "l-aquila"
    }],
    "9d5de329": [{
      "hkey": "288430e7",
      "slug": "pianola-malepasso-san-cipriano-esperita",
      "name": "Pianola-Malepasso-San Cipriano-Esperita",
      "primary": true,
      "skipSearch": false
    }],
    "inciampa-la-notte": [{
      "hkey": "288430e7",
      "slug": "pianola-malepasso-san-cipriano-esperita",
      "name": "Pianola-Malepasso-San Cipriano-Esperita",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "l-aquila"
    }],
    "1ffbf574": [{
      "hkey": "288430e7",
      "slug": "pianola-malepasso-san-cipriano-esperita",
      "name": "Pianola-Malepasso-San Cipriano-Esperita",
      "primary": true,
      "skipSearch": false
    }],
    "malepasso": [{
      "hkey": "288430e7",
      "slug": "pianola-malepasso-san-cipriano-esperita",
      "name": "Pianola-Malepasso-San Cipriano-Esperita",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "l-aquila"
    }],
    "b6729c09": [{
      "hkey": "5a63be8a",
      "slug": "casaline-menzano-santi",
      "name": "Casaline-Menzano-Santi",
      "primary": true,
      "skipSearch": false
    }],
    "menzano": [{
      "hkey": "5a63be8a",
      "slug": "casaline-menzano-santi",
      "name": "Casaline-Menzano-Santi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "l-aquila"
    }],
    "e67f2533": [{
      "hkey": "1862f7e5",
      "slug": "bazzano-monticchio-onna-san-gregorio",
      "name": "Bazzano-Monticchio-Onna-San Gregorio",
      "primary": true,
      "skipSearch": false
    }],
    "monticchio": [{
      "hkey": "1862f7e5",
      "slug": "bazzano-monticchio-onna-san-gregorio",
      "name": "Bazzano-Monticchio-Onna-San Gregorio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "l-aquila"
    }],
    "4b0909f2": [{
      "hkey": "1695ee84",
      "slug": "sassa",
      "name": "Sassa",
      "primary": true,
      "skipSearch": false
    }],
    "palombaia-di-tornimparte": [{
      "hkey": "1695ee84",
      "slug": "sassa",
      "name": "Sassa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "l-aquila"
    }],
    "74cc458d": [{
      "hkey": "288430e7",
      "slug": "pianola-malepasso-san-cipriano-esperita",
      "name": "Pianola-Malepasso-San Cipriano-Esperita",
      "primary": true,
      "skipSearch": false
    }],
    "pianola": [{
      "hkey": "288430e7",
      "slug": "pianola-malepasso-san-cipriano-esperita",
      "name": "Pianola-Malepasso-San Cipriano-Esperita",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b2b7fba1": [{
      "hkey": "5debdebe",
      "slug": "roio",
      "name": "Roio",
      "primary": true,
      "skipSearch": false
    }],
    "poggio-di-roio": [{
      "hkey": "5debdebe",
      "slug": "roio",
      "name": "Roio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "l-aquila"
    }],
    "931442d8": [{
      "hkey": "947f27c5",
      "slug": "preturo-colle-di-preturo-cese",
      "name": "Preturo-Colle di Preturo-Cese",
      "primary": true,
      "skipSearch": false
    }],
    "preturo": [{
      "hkey": "947f27c5",
      "slug": "preturo-colle-di-preturo-cese",
      "name": "Preturo-Colle di Preturo-Cese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f2ac8761": [{
      "hkey": "5debdebe",
      "slug": "roio",
      "name": "Roio",
      "primary": true,
      "skipSearch": false
    }],
    "roio-piano": [{
      "hkey": "5debdebe",
      "slug": "roio",
      "name": "Roio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "l-aquila"
    }],
    "15044835": [{
      "hkey": "924b0799",
      "slug": "bagno",
      "name": "Bagno",
      "primary": true,
      "skipSearch": false
    }],
    "san-benedetto": [{
      "hkey": "924b0799",
      "slug": "bagno",
      "name": "Bagno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "l-aquila"
    }],
    "7ede94e0": [{
      "hkey": "288430e7",
      "slug": "pianola-malepasso-san-cipriano-esperita",
      "name": "Pianola-Malepasso-San Cipriano-Esperita",
      "primary": true,
      "skipSearch": false
    }],
    "san-cipriano": [{
      "hkey": "288430e7",
      "slug": "pianola-malepasso-san-cipriano-esperita",
      "name": "Pianola-Malepasso-San Cipriano-Esperita",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "l-aquila"
    }],
    "56d42218": [{
      "hkey": "1862f7e5",
      "slug": "bazzano-monticchio-onna-san-gregorio",
      "name": "Bazzano-Monticchio-Onna-San Gregorio",
      "primary": true,
      "skipSearch": false
    }],
    "san-gregorio": [{
      "hkey": "1862f7e5",
      "slug": "bazzano-monticchio-onna-san-gregorio",
      "name": "Bazzano-Monticchio-Onna-San Gregorio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "l-aquila"
    }],
    "892e59fb": [{
      "hkey": "5a63be8a",
      "slug": "casaline-menzano-santi",
      "name": "Casaline-Menzano-Santi",
      "primary": true,
      "skipSearch": false
    }],
    "santi": [{
      "hkey": "5a63be8a",
      "slug": "casaline-menzano-santi",
      "name": "Casaline-Menzano-Santi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "l-aquila"
    }],
    "60b44692": [{
      "hkey": "f37fa3c7",
      "slug": "l-aquila",
      "name": "L'Aquila",
      "primary": true,
      "skipSearch": false
    }],
    "aquilio": [{
      "hkey": "f37fa3c7",
      "slug": "l-aquila",
      "name": "L'Aquila",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "078bfb0f": [{
      "hkey": "f72d5f91",
      "slug": "assergi-fonte-cerreto",
      "name": "Assergi-Fonte Cerreto",
      "primary": true,
      "skipSearch": false
    }],
    "assergi": [{
      "hkey": "f72d5f91",
      "slug": "assergi-fonte-cerreto",
      "name": "Assergi-Fonte Cerreto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e771b7c9": [{
      "hkey": "1695ee84",
      "slug": "sassa",
      "name": "Sassa",
      "primary": true,
      "skipSearch": false
    }],
    "brecciasecca": [{
      "hkey": "1695ee84",
      "slug": "sassa",
      "name": "Sassa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "l-aquila"
    }],
    "89920c3f": [{
      "hkey": "fc3c138b",
      "slug": "cansatessa-pettino",
      "name": "Cansatessa-Pettino",
      "primary": true,
      "skipSearch": false
    }],
    "cansatessa": [{
      "hkey": "fc3c138b",
      "slug": "cansatessa-pettino",
      "name": "Cansatessa-Pettino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "2df9a5db": [{
      "hkey": "f37fa3c7",
      "slug": "l-aquila",
      "name": "L'Aquila",
      "primary": true,
      "skipSearch": false
    }],
    "cesa-nuova": [{
      "hkey": "f37fa3c7",
      "slug": "l-aquila",
      "name": "L'Aquila",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "17470249": [{
      "hkey": "1695ee84",
      "slug": "sassa",
      "name": "Sassa",
      "primary": true,
      "skipSearch": false
    }],
    "colle-di-sassa": [{
      "hkey": "1695ee84",
      "slug": "sassa",
      "name": "Sassa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "l-aquila"
    }],
    "7a7c79bd": [{
      "hkey": "1695ee84",
      "slug": "sassa",
      "name": "Sassa",
      "primary": true,
      "skipSearch": false
    }],
    "collefracido": [{
      "hkey": "1695ee84",
      "slug": "sassa",
      "name": "Sassa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "l-aquila"
    }],
    "e9b78375": [{
      "hkey": "1695ee84",
      "slug": "sassa",
      "name": "Sassa",
      "primary": true,
      "skipSearch": false
    }],
    "collemare": [{
      "hkey": "1695ee84",
      "slug": "sassa",
      "name": "Sassa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "l-aquila"
    }],
    "8c8c7737": [{
      "hkey": "1695ee84",
      "slug": "sassa",
      "name": "Sassa",
      "primary": true,
      "skipSearch": false
    }],
    "foce": [{
      "hkey": "1695ee84",
      "slug": "sassa",
      "name": "Sassa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "l-aquila"
    }],
    "5228c319": [{
      "hkey": "f37fa3c7",
      "slug": "l-aquila",
      "name": "L'Aquila",
      "primary": true,
      "skipSearch": false
    }],
    "fonte-augelli": [{
      "hkey": "f37fa3c7",
      "slug": "l-aquila",
      "name": "L'Aquila",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "51d0e256": [{
      "hkey": "f37fa3c7",
      "slug": "l-aquila",
      "name": "L'Aquila",
      "primary": true,
      "skipSearch": false
    }],
    "fonte-mortale": [{
      "hkey": "f37fa3c7",
      "slug": "l-aquila",
      "name": "L'Aquila",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9fb676d9": [{
      "hkey": "1695ee84",
      "slug": "sassa",
      "name": "Sassa",
      "primary": true,
      "skipSearch": false
    }],
    "genzano": [{
      "hkey": "1695ee84",
      "slug": "sassa",
      "name": "Sassa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "l-aquila"
    }],
    "788f5593": [{
      "hkey": "f37fa3c7",
      "slug": "l-aquila",
      "name": "L'Aquila",
      "primary": true,
      "skipSearch": false
    }],
    "onna": [{
      "hkey": "f37fa3c7",
      "slug": "l-aquila",
      "name": "L'Aquila",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d038e912": [{
      "hkey": "f37fa3c7",
      "slug": "l-aquila",
      "name": "L'Aquila",
      "primary": true,
      "skipSearch": false
    }],
    "paesi-zona-est": [{
      "hkey": "f37fa3c7",
      "slug": "l-aquila",
      "name": "L'Aquila",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c5e490b7": [{
      "hkey": "f37fa3c7",
      "slug": "l-aquila",
      "name": "L'Aquila",
      "primary": true,
      "skipSearch": false
    }],
    "paesi-zona-ovest": [{
      "hkey": "f37fa3c7",
      "slug": "l-aquila",
      "name": "L'Aquila",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1290049a": [{
      "hkey": "1695ee84",
      "slug": "sassa",
      "name": "Sassa",
      "primary": true,
      "skipSearch": false
    }],
    "pagliare": [{
      "hkey": "1695ee84",
      "slug": "sassa",
      "name": "Sassa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "l-aquila"
    }],
    "629efd3f": [{
      "hkey": "1695ee84",
      "slug": "sassa",
      "name": "Sassa",
      "primary": true,
      "skipSearch": false
    }],
    "palombaia-di-sassa": [{
      "hkey": "1695ee84",
      "slug": "sassa",
      "name": "Sassa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "l-aquila"
    }],
    "d089e767": [{
      "hkey": "fc3c138b",
      "slug": "cansatessa-pettino",
      "name": "Cansatessa-Pettino",
      "primary": true,
      "skipSearch": false
    }],
    "pettino": [{
      "hkey": "fc3c138b",
      "slug": "cansatessa-pettino",
      "name": "Cansatessa-Pettino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "l-aquila"
    }],
    "aa93192e": [{
      "hkey": "548fb495",
      "slug": "santa-barbara-san-sisto",
      "name": "Santa Barbara-San Sisto",
      "primary": true,
      "skipSearch": false
    }],
    "piazza-darmi": [{
      "hkey": "548fb495",
      "slug": "santa-barbara-san-sisto",
      "name": "Santa Barbara-San Sisto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "l-aquila"
    }],
    "7cd451b3": [{
      "hkey": "1695ee84",
      "slug": "sassa",
      "name": "Sassa",
      "primary": true,
      "skipSearch": false
    }],
    "poggio-santa-maria": [{
      "hkey": "1695ee84",
      "slug": "sassa",
      "name": "Sassa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "l-aquila"
    }],
    "6bd4ff5c": [{
      "hkey": "4f5a9cf5",
      "slug": "pozza-san-marco",
      "name": "Pozza-San Marco",
      "primary": true,
      "skipSearch": false
    }],
    "pozza": [{
      "hkey": "4f5a9cf5",
      "slug": "pozza-san-marco",
      "name": "Pozza-San Marco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "3fedd80b": [{
      "hkey": "f37fa3c7",
      "slug": "l-aquila",
      "name": "L'Aquila",
      "primary": true,
      "skipSearch": false
    }],
    "pratelle-sant-antonio": [{
      "hkey": "f37fa3c7",
      "slug": "l-aquila",
      "name": "L'Aquila",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2e5dab1f": [{
      "hkey": "f37fa3c7",
      "slug": "l-aquila",
      "name": "L'Aquila",
      "primary": true,
      "skipSearch": false
    }],
    "ripa": [{
      "hkey": "f37fa3c7",
      "slug": "l-aquila",
      "name": "L'Aquila",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7e8633c7": [{
      "hkey": "548fb495",
      "slug": "santa-barbara-san-sisto",
      "name": "Santa Barbara-San Sisto",
      "primary": true,
      "skipSearch": false
    }],
    "s-barbara": [{
      "hkey": "548fb495",
      "slug": "santa-barbara-san-sisto",
      "name": "Santa Barbara-San Sisto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "d451c19e": [{
      "hkey": "548fb495",
      "slug": "santa-barbara-san-sisto",
      "name": "Santa Barbara-San Sisto",
      "primary": true,
      "skipSearch": false
    }],
    "s-sisto": [{
      "hkey": "548fb495",
      "slug": "santa-barbara-san-sisto",
      "name": "Santa Barbara-San Sisto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "l-aquila"
    }],
    "9e92fe3e": [{
      "hkey": "f37fa3c7",
      "slug": "l-aquila",
      "name": "L'Aquila",
      "primary": true,
      "skipSearch": false
    }],
    "san-giuliano": [{
      "hkey": "f37fa3c7",
      "slug": "l-aquila",
      "name": "L'Aquila",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "acc41a45": [{
      "hkey": "4f5a9cf5",
      "slug": "pozza-san-marco",
      "name": "Pozza-San Marco",
      "primary": true,
      "skipSearch": false
    }],
    "san-marco": [{
      "hkey": "4f5a9cf5",
      "slug": "pozza-san-marco",
      "name": "Pozza-San Marco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "l-aquila"
    }],
    "869b1fe6": [{
      "hkey": "4f5a9cf5",
      "slug": "pozza-san-marco",
      "name": "Pozza-San Marco",
      "primary": true,
      "skipSearch": false
    }],
    "san-marco-di-preturo": [{
      "hkey": "4f5a9cf5",
      "slug": "pozza-san-marco",
      "name": "Pozza-San Marco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "l-aquila"
    }],
    "5906a13a": [{
      "hkey": "1695ee84",
      "slug": "sassa",
      "name": "Sassa",
      "primary": true,
      "skipSearch": false
    }],
    "san-martino": [{
      "hkey": "1695ee84",
      "slug": "sassa",
      "name": "Sassa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "l-aquila"
    }],
    "91f763e7": [{
      "hkey": "f37fa3c7",
      "slug": "l-aquila",
      "name": "L'Aquila",
      "primary": true,
      "skipSearch": false
    }],
    "san-raniero": [{
      "hkey": "f37fa3c7",
      "slug": "l-aquila",
      "name": "L'Aquila",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "12fd4004": [{
      "hkey": "36f0c0a2",
      "slug": "san-vittorino",
      "name": "San Vittorino",
      "primary": true,
      "skipSearch": false
    }],
    "san-vittorino-amiterno": [{
      "hkey": "36f0c0a2",
      "slug": "san-vittorino",
      "name": "San Vittorino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "l-aquila"
    }],
    "8df88483": [{
      "hkey": "1695ee84",
      "slug": "sassa",
      "name": "Sassa",
      "primary": true,
      "skipSearch": false
    }],
    "sassa-scalo": [{
      "hkey": "1695ee84",
      "slug": "sassa",
      "name": "Sassa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "l-aquila"
    }],
    "c9476a2f": [{
      "hkey": "b7108275",
      "slug": "san-giacomo-torrione",
      "name": "San Giacomo-Torrione",
      "primary": true,
      "skipSearch": false
    }],
    "torrione": [{
      "hkey": "b7108275",
      "slug": "san-giacomo-torrione",
      "name": "San Giacomo-Torrione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "009fcb5c": [{
      "hkey": "999ce0a7",
      "slug": "centro-storico",
      "name": "Centro storico",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "2ce4e068",
      "slug": "sant-elia-torretta",
      "name": "Sant'Elia-Torretta",
      "primary": false,
      "skipSearch": false
    }],
    "via-strinella": [{
      "hkey": "999ce0a7",
      "slug": "centro-storico",
      "name": "Centro storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "l-aquila"
    }],
    "ed36cf54": [{
      "hkey": "999ce0a7",
      "slug": "centro-storico",
      "name": "Centro storico",
      "primary": true,
      "skipSearch": false
    }],
    "villa-comunale": [{
      "hkey": "999ce0a7",
      "slug": "centro-storico",
      "name": "Centro storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "l-aquila"
    }],
    "3dee3aa3": [{
      "hkey": "2ce4e068",
      "slug": "sant-elia-torretta",
      "name": "Sant'Elia-Torretta",
      "primary": true,
      "skipSearch": false
    }],
    "zona-est-torretta-s-elia": [{
      "hkey": "2ce4e068",
      "slug": "sant-elia-torretta",
      "name": "Sant'Elia-Torretta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;